import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { SiteConfigurationTemplate } from '../../../types';
import { StatusChip } from '../StatusChip';
import { EmptySection } from '../EmptySection';

type ControllersSectionProps = {
  template: SiteConfigurationTemplate;
};

export const ControllersSection = ({ template }: ControllersSectionProps) => {
  const rows = template.controllers;
  if (!rows.length) return <EmptySection label="Controllers" />;

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Controller Name</TableCell>
            <TableCell>Controller Type</TableCell>
            <TableCell align="right">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((ctrl) => (
            <TableRow key={ctrl.id}>
              <TableCell>{ctrl.controllerName || '—'}</TableCell>
              <TableCell>{ctrl.controllerType || '—'}</TableCell>
              <TableCell align="right">
                {/* Controllers have no tag deps — always included */}
                <StatusChip included />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
